import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useResumeCardContext from "../ResumeCardContext";
import Label from "src/components/Label";
import Button from "src/components/Button";
import useAuth from "src/hooks/selectors/useAuth";
import useBackUrl from "src/hooks/useBackUrl";

interface ResumeSkillsProps extends Translation {
	editable?: boolean;
}

function ResumeSkills({ t, editable }: ResumeSkillsProps) {
	const auth = useAuth();
	const { resume } = useResumeCardContext();
	const backgroundColor = resume.primary_color;
	const backUrl = useBackUrl();

	if (!resume?.skills?.length && resume.id === auth.id && editable) {
		return (
			<div
				style={{ backgroundColor }}
				className={`flex rounded-lg flex-col text-center ${
					editable ? "gap-6" : "gap-8"
				} p-4 md:p-8`}
			>
				<div className="flex flex-row justify-center items-center">
					<h3 className="text-white">{t("empty-title")}</h3>
					<Button
						type="none"
						iconOnly={true}
						className="text-white"
						icon="far fa-pencil"
						to={`/profile/resume/create/skill?${backUrl}`}
					/>
				</div>
			</div>
		);
	}

	if (!resume?.skills || !resume?.skills.length) {
		return <></>;
	}

	return (
		<div
			style={{ backgroundColor }}
			className={`flex rounded-lg flex-col text-center ${
				editable ? "gap-6" : "gap-8"
			} px-4 py-8 md:p-8`}
		>
			{editable ? (
				<div className="flex flex-row justify-center items-center">
					<h3 className="text-white">{t("title")}</h3>
					<Button
						type="none"
						iconOnly={true}
						className="text-white"
						icon="far fa-pencil"
						to={`/profile/resume/create/skill?${backUrl}`}
					/>
				</div>
			) : (
				<h3 className="text-white">{t("title")}</h3>
			)}
			<div className="flex gap-2 flex-wrap justify-center">
				{resume?.skills.map((item: any) => (
					<Label
						type="white"
						key={item.id}
						endorsements={item?.endorsements}
					>
						<div className="flex items-center">{item.name}</div>
					</Label>
				))}
			</div>
		</div>
	);
}

ResumeSkills.locale = {
	nl: {
		title: "Vaardigheden",
		"empty-title": "Geen vaardigheden gevonden",
	},
	en: {
		title: "Skills",
		"empty-title": "No skills found",
	},
};

export default withTranslation(ResumeSkills);
